import type { Move } from '../../../schemas/move';
import { bardoArchetypeMoves } from './archetypes';
import { bardoInitialMoves, bardoStartingAutoMoves, bardoStartingChoiceMoves } from './initial';
import { bardoAdvanced2to5Moves } from './advanced-2-5';
import { bardoAdvanced6to10Moves } from './advanced-6-10';

export {
  bardoArchetypeMoves,
  bardoInitialMoves,
  bardoStartingAutoMoves,
  bardoStartingChoiceMoves,
  bardoAdvanced2to5Moves,
  bardoAdvanced6to10Moves,
};

/**
 * Catalogo completo delle mosse del Bardo (manuale V1, sezione "Il Bardo").
 *
 * Aggregato di:
 *  - 5 archetipi (`class_special`)
 *  - 3 mosse iniziali automatiche + 4 mosse iniziali di scelta (`starting`,
 *    `pickCount: 2` sul gruppo di scelta)
 *  - 16 mosse avanzate L2-5 (`advanced_2_5`)
 *  - 14 mosse avanzate L6-10 (`advanced_6_10`)
 *
 * Totale: 42 mosse.
 */
export const bardoMoves: readonly Move[] = [
  ...bardoArchetypeMoves,
  ...bardoInitialMoves,
  ...bardoAdvanced2to5Moves,
  ...bardoAdvanced6to10Moves,
];
